var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDogsOn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2418",
    d: "M0-682.665H43.91v41.63H0Z",
    transform: "translate(0 682.665)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeWidth: 1.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_368",
    "data-name": "Group 368",
    transform: "translate(-1018 -286)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_3097",
    "data-name": "Path 3097",
    transform: "translate(1018 286)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 34 67 C 29.54458999633789 67 25.22298049926758 66.12761688232422 21.15522003173828 64.40711212158203 C 17.2257194519043 62.74507141113281 13.69645977020264 60.36550903320312 10.66547966003418 57.33451843261719 C 7.634490013122559 54.30353927612305 5.254930019378662 50.7742805480957 3.592890024185181 46.84477996826172 C 1.872380018234253 42.77701950073242 1 38.45541000366211 1 34 C 1 29.54458999633789 1.872380018234253 25.22298049926758 3.592890024185181 21.15522003173828 C 5.254930019378662 17.2257194519043 7.634490013122559 13.69645977020264 10.66547966003418 10.66547966003418 C 13.69645977020264 7.634490013122559 17.2257194519043 5.254930019378662 21.15522003173828 3.592890024185181 C 25.22298049926758 1.872380018234253 29.54458999633789 1 34 1 C 38.45541000366211 1 42.77701950073242 1.872380018234253 46.84477996826172 3.592890024185181 C 50.7742805480957 5.254930019378662 54.30353927612305 7.634490013122559 57.33451843261719 10.66547966003418 C 60.36550903320312 13.69645977020264 62.74507141113281 17.2257194519043 64.40711212158203 21.15522003173828 C 66.12761688232422 25.22298049926758 67 29.54458999633789 67 34 C 67 38.45541000366211 66.12761688232422 42.77701950073242 64.40711212158203 46.84477996826172 C 62.74507141113281 50.7742805480957 60.36550903320312 54.30353927612305 57.33451843261719 57.33451843261719 C 54.30353927612305 60.36550903320312 50.7742805480957 62.74507141113281 46.84477996826172 64.40711212158203 C 42.77701950073242 66.12761688232422 38.45541000366211 67 34 67 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34 2 C 29.67914581298828 2 25.48860168457031 2.845802307128906 21.54476547241211 4.513900756835938 C 17.73447799682617 6.125522613525391 14.31205368041992 8.433109283447266 11.37258911132812 11.37258911132812 C 8.433109283447266 14.31205368041992 6.125522613525391 17.73447799682617 4.513900756835938 21.54476547241211 C 2.845802307128906 25.48860168457031 2 29.67914581298828 2 34 C 2 38.32085418701172 2.845802307128906 42.51139831542969 4.513900756835938 46.45523071289062 C 6.125522613525391 50.26552200317383 8.433109283447266 53.68794250488281 11.37258911132812 56.62741088867188 C 14.31205368041992 59.56688690185547 17.73447799682617 61.87447738647461 21.54476547241211 63.48609924316406 C 25.48860168457031 65.15419769287109 29.67914581298828 66 34 66 C 38.32085418701172 66 42.51139831542969 65.15419769287109 46.45523071289062 63.48609924316406 C 50.26552200317383 61.87447738647461 53.68794250488281 59.56688690185547 56.62741088867188 56.62741088867188 C 59.56688690185547 53.68794250488281 61.87447738647461 50.26552200317383 63.48609924316406 46.45523071289062 C 65.15419769287109 42.51139831542969 66 38.32085418701172 66 34 C 66 29.67914581298828 65.15419769287109 25.48860168457031 63.48609924316406 21.54476547241211 C 61.87447738647461 17.73447799682617 59.56688690185547 14.31205368041992 56.62741088867188 11.37258911132812 C 53.68794250488281 8.433109283447266 50.26552200317383 6.125522613525391 46.45523071289062 4.513900756835938 C 42.51139831542969 2.845802307128906 38.32085418701172 2 34 2 M 34 0 C 52.77767944335938 0 68 15.22232055664062 68 34 C 68 52.77767944335938 52.77767944335938 68 34 68 C 15.22232055664062 68 0 52.77767944335938 0 34 C 0 15.22232055664062 15.22232055664062 0 34 0 Z",
    stroke: "none",
    fill: "#afdcc6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2414",
    transform: "translate(1030 299)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2416",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g2422",
    transform: "translate(9.554 1.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2424",
    d: "M0-603.474H23.424v-2.613a2.687,2.687,0,0,0-2.756-2.613v-5.225a8.69,8.69,0,0,0,4.134-7.323v-10.966h4.134a4.031,4.031,0,0,0,4.134-3.919v-2.613H27.558l-4.134-3.919H19.289a7.085,7.085,0,0,0-4.871,1.912,6.364,6.364,0,0,0-2.017,4.618h0a10.5,10.5,0,0,1-4.35,8.433l-2.466,1.818A13.475,13.475,0,0,0,0-615.055Z",
    transform: "translate(0 642.665)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2426",
    transform: "translate(15.066 28.653)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2428",
    d: "M-160.354-181.042h0a5.336,5.336,0,0,0-2.847-4.575,5.331,5.331,0,0,0-2.664-.65v-1.308a5.09,5.09,0,0,0-1.614-3.694,11.8,11.8,0,0,0-3.239-1.493,5.916,5.916,0,0,0-.657-.037h0",
    transform: "translate(171.377 192.8)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2430",
    transform: "translate(21.955 1.22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2432",
    d: "M-100.221,0h0a7.085,7.085,0,0,0-4.871,1.913,6.363,6.363,0,0,0-2.017,4.618V9.8a3.359,3.359,0,0,0,3.445,3.266A3.359,3.359,0,0,0-100.221,9.8V5.225",
    transform: "translate(107.11)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2434",
    transform: "translate(1.286 35.185)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2436",
    d: "M0-20.115a3.819,3.819,0,0,0,1.21,2.771A4.253,4.253,0,0,0,4.134-16.2H8.267V-17.5a3.819,3.819,0,0,0-1.211-2.771,4.253,4.253,0,0,0-2.923-1.148H0Z",
    transform: "translate(0 21.421)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })), /*#__PURE__*/React.createElement("g", {
    id: "g2438",
    transform: "translate(24.711 29.96)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path2440",
    d: "M0-100.579v-6.532",
    transform: "translate(0 107.11)",
    fill: "none",
    stroke: "#1b9c5d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.4
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDogsOn);
export default __webpack_public_path__ + "static/media/dogs-on.c11fe2aeabca98b11e387805251af9e1.svg";
export { ForwardRef as ReactComponent };